import OtsTableGroup from './OtsTableGroup'

OtsTableGroup.install = Vue => {
    Vue.component(OtsTableGroup.name,OtsTableGroup)
}

export default OtsTableGroup